// Kiểu + hằng dùng chung của Bộ soi ảnh (tách khỏi tệp thành phần cho làm mới nóng của Vite).
import { PAN_CENTER, type Pan, type Zoom } from "./viewport";

export type ViewState = { zoom: Zoom; pan: Pan };
export type CompareMode = "single" | "side" | "wipe" | "flicker" | "diff";
export const FIT_VIEW: ViewState = { zoom: "fit", pan: PAN_CENTER };
export const COMPARE_MODES: CompareMode[] = ["side", "wipe", "flicker", "diff"];

export const MODE_LABEL: Record<CompareMode, string> = {
  single: "Một bản",
  side: "Cạnh nhau",
  wipe: "Thanh gạt",
  flicker: "Nháy",
  diff: "Khác biệt",
};

export type ViewerBg = "auto" | "gray" | "black" | "white";
export const BG_LABEL: Record<ViewerBg, string> = {
  auto: "Nền mặc định",
  gray: "Nền xám trung tính",
  black: "Nền đen",
  white: "Nền trắng",
};

export type ToolFlags = { histogram: boolean; clipping: boolean; eyedropper: boolean; grid: boolean };
export const NO_TOOLS: ToolFlags = { histogram: false, clipping: false, eyedropper: false, grid: false };
export type ColorPin = { r: number; g: number; b: number; hex: string };
